export default __webpack_public_path__ + "static/logo-dark-1927e165f4d735378042e6fb1f356fb3.svg";